import AirHeader from "../../components/AirHeader";
import User from "../../components/menu/User";
import { useMyAirView } from "./hooks/presentation/useMyAirView";
import { useMemo, useState } from "react";
import MyAirV2Content from "./containers/ContentContainer";
import getUserState from "../../views/tutorV2/utils/getUserState";
import SubscriptionPopup from "../subscription/SubscriptionPopup";

const MyAirV2 = () => {
  const { user, userState, handlePurchaseClick } = useMyAirView();
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);

  // 아바타 URL 생성
  const avatarUrl = useMemo(() => {
    if (user?.picture_extension && user?.picture_data) {
      return `data:image/${user.picture_extension};base64,${user.picture_data}`;
    }
    return undefined;
  }, [user]);

  return (
    <div className="h-full flex flex-col">
      <AirHeader type="sub" />
      <User
        state={user ? getUserState(user) : "inactive"}
        email={user?.name}
        avatarUrl={""}
        startDate={user?.start_dt}
        endDate={user?.end_dt}
        showButton={false} // More 버튼 숨김
        onPurchaseClick={handlePurchaseClick}
        showDetail
        onStateChange={(newState) => {
          if (newState === "canceled") {
            setShowSubscriptionPopup(true);
          }
          if (newState === "on_hold") {
            setShowPaymentPopup(true);
          }
        }}
      />
      <div className="bg-white box-border flex flex-col flex-1">
        <MyAirV2Content />
      </div>
      <SubscriptionPopup
        title="구독이 해지되었어요."
        message="종료일까지 계속 이용 가능하지만 다음 결제 갱신은 중단된 상태입니다. 필요하시면 언제든 다시 구독하실 수 있어요."
        open={showSubscriptionPopup}
        onClose={() => setShowSubscriptionPopup(false)}
      />
      <SubscriptionPopup
        title="결제 수단을 확인해주세요."
        message="등록된 결제수단으로 결제가 완료되지 않아 구독이 일시 중지되었습니다. Google Play에서 결제 정보를 업데이트하면 다시 이용하실 수 있어요."
        open={showPaymentPopup}
        onClose={() => setShowPaymentPopup(false)}
      />
    </div>
  );
};

export default MyAirV2;
